import { ListItemButton, styled } from "@mui/material";

const ThemeListLinkButton = styled(ListItemButton,{
        shouldForwardProp: (prop) => prop !== 'isLocation',
    })(({ theme, isLocation }) => ({
    color: isLocation ? theme.palette.text.disabled : theme.palette.text.primary,
}));

export default ThemeListLinkButton;